import type { ObservationDeleteOptions } from "./observation-delete.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

import { getObservationInvalidate } from "../observation-invalidate";

export const useObservationDelete = (
  observationId: number,
  options: ObservationDeleteOptions = {}
) => {
  const onSuccess = useMutationOnSuccess({
    onSuccess: options.onSuccess,
    onSuccessAwaited: options.onSuccessAwaited,
    invalidate: getObservationInvalidate(observationId, options.invalidate),
  });

  const { mutate, isPending } = useMutation<ApiEmptyResponse, ApiError>({
    mutationKey: ["observations", "delete", observationId],
    mutationFn: () => client.observations.destroy(observationId),
    onSuccess,
  });

  return {
    deleteObservation: mutate,
    isPending,
  };
};
